<template>
  <div class="container-showcase">
    <div class="container-fluid">
      <div class="card" v-if="this.rankToday.length != 0">
        <h3>{{translation.top_affiliates_today}}</h3>
        <div class="showcase">
          <div class="card__user" v-for="(lead, index) in this.rankToday" :key="index">
            <img :src="lead.image">
            <div>
              <h5>{{lead.name}}</h5>
              <h5>{{translation.total_points}} {{lead.points}}</h5>
              <div class="status">
                <span class="payment active" data-value="active">{{translation.active}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="this.rankWeek.length != 0">
        <h3>{{translation.top_affiliates_week}}</h3>
        <div class="showcase">
          <div class="card__user" v-for="(lead, index) in this.rankWeek" :key="index">
            <img :src="lead.image">
            <div>
              <h5>{{lead.name}}</h5>
              <h5>{{translation.total_points}} {{lead.points}}</h5>
              <div class="status">
                <span class="payment active" data-value="active">{{translation.active}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="this.rankAllTime.length != 0">
        <h3>{{translation.top_affiliates_all_times}}</h3>
        <div class="showcase">
          <div class="card__user" v-for="(lead, index) in this.rankAllTime" :key="index">
            <img :src="lead.image">
            <div>
              <h5>{{lead.name}}</h5>
              <h5>{{translation.total_points}} {{lead.points}}</h5>
              <div class="status">
                <span class="payment active" data-value="active">{{translation.active}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "affiliates-show-case",
  props: ["props"],
  components: {},
  data() {
    return {
      translation: this.$parent.$parent.view.translation.affiliatesShowCase,
      rankToday: [],
      rankWeek: [],
      rankAllTime: [],
      allResponse: null
    };
  },
  methods: {
    handleRanking() {
      fetch("https://bucket.services.builderall.com/ranking", {
        mode: "cors",
        headers: {
          Origin: "*"
        }
      })
        .then(res => {
          return res.text();
        })
        .then(data => {
          this.allResponse = JSON.parse(data);
          this.rankToday = this.allResponse.now;
          this.rankWeek = this.allResponse.week;
          this.rankAllTime = this.allResponse.all;
        });
    }
  },
  mounted() {
    this.handleRanking();
    // console.log(this.props);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container-showcase {
  padding-right: 10px;
  padding-left: 10px;
}
.card {
  margin-bottom: 25px;
  margin-top: 25px;
}
.showcase {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 -0.4rem;
  .card__user {
    display: flex;
    align-items: center;
    padding: 0.4rem 0.6rem;
    border: 1px solid #eaeef0;
    border-radius: 7px;
    width: 100%;    
    flex: 1 1 auto;
    margin: 0.4rem;
    @media (min-width: 768px) {
      width: calc(50% - 0.8rem);
    }
    @media (min-width: 1024px) {
      width: calc(33% - 0.8rem);
    }
    @media (min-width: 1440px) {
      width: calc(25% - 0.8rem);
    }
    @media (min-width: 1920px) {
      width: calc(14% - 0.8rem);
    }
    img {
      height: 50px;
      width: auto;
      border-radius: 50%;
      margin-right: 0.3rem;
    }
    h5 {
      margin: 0;
      color: #818a91;
      &:first-child {
        width: 90px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
      }
    }
    .status {
      color: #fff;
      display: table;
      height: 16px;
      line-height: 16px;
      overflow: hidden;
      float: left;
      margin-top: 0.3rem;
      span {
        float: left;
        padding: 0 5px;
        font-size: 10px;
        font-weight: bold;
        text-transform: uppercase;
        border-radius: 16px;

        &.payment {
          transition: all 250ms ease-in;
          min-width: 16px;
          &:not(:hover) {
            font-size: 0;
          }
          &.active {
            background-color: #55efc4;
          }
          &.inactive {
            background-color: #ff7675;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/affiliatesShowCase.vue